import { storeS } from '@/store.js'

export function fillStruct() {
    let struct = [
        {
            label: "Додатки",
            options: []
        },
        {
            label: "POS",
            options: []
        },
        {
            label: "Адмінка",
            options: []
        },
        {
            label: "SkyOwner",
            options: []
        },
        {
            label: "Inside",
            options: []
        }
    ]

    for(var item in storeS.developmentProjects){
        console.log(storeS.developmentProjects[item])
        if (storeS.developmentProjects[item].projectName.includes('Додаток') === true) {
            struct[0].options.push({
                label: storeS.developmentProjects[item].projectName,
                value: storeS.developmentProjects[item].projectKey
            })
        } else if(storeS.developmentProjects[item].projectName.includes('POS') === true) {
            struct[1].options.push({
                label: storeS.developmentProjects[item].projectName,
                value: storeS.developmentProjects[item].projectKey
            })
        } else if(storeS.developmentProjects[item].projectName.includes('SkyOwner') === true){
            struct[3].options.push({
                label: storeS.developmentProjects[item].projectName,
                value: storeS.developmentProjects[item].projectKey
            })
        } else if(storeS.developmentProjects[item].projectName.includes('Inside') === false){ // цей if на пошук продуктів адмінки
            struct[2].options.push({
                label: storeS.developmentProjects[item].projectName,
                value: storeS.developmentProjects[item].projectKey
            })
        } else if(storeS.developmentProjects[item].projectName.includes('Inside') === true){
            struct[4].options.push({
                label: storeS.developmentProjects[item].projectName,
                value: storeS.developmentProjects[item].projectKey
            })
        }
    }
    
    return struct
}